// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://dyakqbhcepjcommcflru.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR5YWtxYmhjZXBqY29tbWNmbHJ1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYwNDMwMTcsImV4cCI6MjA3MTYxOTAxN30.oSKe3VAoqj-NZ19it8WfRB01_4MaFZupNdGzHRqDgCM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
    // Bypass navigator.locks to prevent "Lock broken by another request with 'steal' option"
    // when browser tab resumes from background suspend
    lock: async (_name: string, _acquireTimeout: number, fn: () => Promise<any>) => fn(),
  }
});